import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Fullscreen from 'material-ui/svg-icons/navigation/fullscreen';
import FullscreenExit from 'material-ui/svg-icons/navigation/fullscreen-exit';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {grey400, white} from 'material-ui/styles/colors';
import {Link} from "react-router-dom";
import {Paper, Subheader} from "material-ui";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './PointPage.css';
import AdminService, {ADMIN} from '../../../services/admin';
import {deletePoint, fetchPoint, getPoint, postPointMedia} from "../../../store/points/actions";
import PointInfo from "../../../components/openexplore/PointInfo/PointInfo";
import MediaBlocs from "../../../components/media/MediaBlocs/MediaBlocs";
import {getTypes} from "../../../store/types/actions";
import DumbTypeList from "../../../components/type/DumbTypeList/DumbTypeList";
import {getCustomFields} from "../../../store/customfields/actions";
import CommentList from "../../../components/comment/CommentList/CommentList";
import {deleteComment} from "../../../store/comments/actions";
import ModuleService from '../../../services/module';
import Mapbox from "../../../components/openexplore/Mapbox/Mapbox";
import withTranslation from "../../../hoc/withTranslation";
import {EDIT_POINT_PAGE, MIME_MEDIA_LIST_PAGE, OPENEXPLORE_PAGE} from "../../../constants/routes";
import { EXTERNAL } from '../../../constants/sources';
import ImportIndicator from '../../../components/import/ImportIndicator';
import CommentService from '../../../services/comment';
import APIService from "../../../services/api";
import {Cookies} from "react-cookie";
import {PDF} from "../../../constants/format";

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

const cookies = new Cookies();

export class PointPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        point: PropTypes.object
    };

    static defaultProps = {
        loading: false
    };

    state = {
        openRemovePoint: false,
        commentToDelete: null,
        openDeleteComment: false,
        mapFullscreen: false
    };

    componentWillMount() {
        this.fetch();

        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.currentLang);
            this.props.getCustomFields(this.props.app.id);
        }

        if (this.props.point) {
            this.setState({
                latlng: {
                    lat: this.props.point.latitude,
                    lng: this.props.point.longitude,
                    shouldCenter: true
                }
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match || this.props.currentLang !== nextProps.currentLang) {
            this.fetch(nextProps.match.params.appId, nextProps.match.params.pointId, nextProps.currentLang)
        }

        if (this.props.sending && !nextProps.sending) {
            if (!nextProps.point) { // Point has been deleted
                this.props.history.push(OPENEXPLORE_PAGE.replace(':appId', this.props.app.id));
            }
        }

        if (this.props.commentSending && !nextProps.commentSending) {
            this.handleCloseDeleteComment();
            this.getPoint();
        }

        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.currentLang);
            this.props.getCustomFields(nextProps.app.id);
        }

        if (nextProps.point && (!this.state.latlng || this.props.point !== nextProps.point)) {
            this.setState({
                latlng: {
                    lat: nextProps.point.latitude,
                    lng: nextProps.point.longitude,
                    shouldCenter: true
                }
            });
        }
    }

    // Download point export PDF
    getPdfExport = async() => {
        try {
            this.setState({ loadingPdfExport: true });
            const response = await APIService.getPoint(
                this.props.app.id,
                this.props.point.id,
                cookies.get('token'),
                this.props.currentLang,
                PDF,
                true,
            );
            const type = response.headers['content-type'] || 'application/pdf';
            const contentDisposition = response.headers['content-disposition'];
            const today = new Date();
            let filename = 'point_' + today.toLocaleDateString() + '_' + today.toLocaleTimeString() + '.pdf';
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }
            const blob = new Blob([response.data],
                {
                    type: type,
                },
            );
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({ loadingPdfExport: false });
        }
    };

    // Delete point

    handleOpenPoint = () => {
        this.setState({openRemovePoint: true});
    };

    handleClosePoint = () => {
        this.setState({openRemovePoint: false});
    };

    deletePoint = () => {
        this.props.deletePoint(this.props.app.id, this.props.point.id, this.props.currentLang);
    };

    selectMime = (mime) => {
        let url = MIME_MEDIA_LIST_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':entityType', 'points')
            .replace(':entityId', this.props.point.id)
            .replace(':shortMime', mime);
        this.props.history.push(url);
    };

    // Delete comment

    handleDeleteComment = (comment) => {
        this.setState({
            openDeleteComment: true,
            commentToDelete: comment
        });
    };

    handleCloseDeleteComment = () => {
        this.setState({
            openDeleteComment: false,
            commentToDelete: null
        });
    };

    deleteComment = () => {
        this.props.deleteComment(this.props.app.id, this.state.commentToDelete.id);
    };

    switchFullScreen = () => {
        this.setState({
            mapFullscreen: !this.state.mapFullscreen
        })
    };


    // Fetch

    fetch(appId = null, pointId = null, lang = null) {
        this.fetchApplication(appId);
        this.fetchPoint(appId, pointId, lang);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchPoint(appId = null, pointId = null, fetchLang = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const point = pointId || this.props.match.params.pointId;
            const lang = fetchLang || this.props.currentLang;

            if (app && point) {
                this.props.fetchPoint(app, point, lang)
            }
        }
    }

    getPoint(appId = null, pointId = null, fetchLang = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const point = pointId || this.props.match.params.pointId;
            const lang = fetchLang || this.props.currentLang;

            if (app && point) {
                this.props.getPoint(app, point, lang)
            }
        }
    }

    // Render

    renderMenu() {
        let menu;

        if (AdminService.isAuthorized(ADMIN, this.props.user)) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                    <Link
                        to={EDIT_POINT_PAGE.replace(':appId', this.props.app.id).replace(':pointId', this.props.point.id)}>
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                    <MenuItem onClick={this.getPdfExport}>
                        {this.props.t('generic.export')}
                    </MenuItem>
                    <MenuItem onClick={this.handleOpenPoint}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                </IconMenu>
            );
        }

        return menu;
    };

    renderDeleteCommentDialog(comment) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.commentSending}
                onClick={this.handleCloseDeleteComment}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.commentSending}
                onClick={this.deleteComment}
            />
        ];
        const text = CommentService.getTextForComment(
            this.props.t,
            comment,
            'module.comment.delete_comment_confirmation'
        );
        return (
            <Dialog actions={actions}
                    title={this.props.t('module.comment.reject_comment')}
                    modal={this.props.commentSending}
                    open={this.state.openDeleteComment}
                    onRequestClose={this.handleCloseDeleteComment}>
                {this.props.commentSending && <Loading paper={false} />}
                {!this.props.commentSending &&
                <p>
                    <div dangerouslySetInnerHTML={{ __html: text}} />
                </p>
                }
            </Dialog>
        );
    }

    renderDeletePointDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleClosePoint}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deletePoint}
            />
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemovePoint}
                onRequestClose={this.handleClosePoint}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>{this.props.t('module.open_explore.delete_point_confirmation')}</p>
                }
            </Dialog>
        );
    }

    renderMap() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <Paper>
                    <Subheader style={{...style.subHeader, ...style.relative}}>
                        {this.props.t('generic.map')}
                        <IconButton
                            style={styles.rightIcon}
                            tooltip={this.props.t('module.open_explore.map_fullscreen')}
                            tooltipPosition='bottom-left'
                            onClick={this.switchFullScreen}
                        >
                            {this.state.mapFullscreen ?
                                <FullscreenExit color={white} />
                                :
                                <Fullscreen color={white} />
                            }
                        </IconButton>
                    </Subheader>
                    <Mapbox
                        latlng={this.state.latlng}
                        scrollWheelZoom={false}
                        canShowDetail={false}
                        points={[]}
                        trails={[]}
                        style={this.state.mapFullscreen ? styles.mapFull : styles.map}
                        mapStyle={this.props.mapStyle}
                    />
                </Paper>
            </div>
        );
    }

    renderInformation() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <PointInfo
                    point={this.props.point}
                    customFields={this.props.customFields}
                    app={this.props.app}
                    lang={this.props.currentLang}
                />
            </div>
        );
    }

    renderTypes() {
        const types = this.props.types.filter((type) => {
            return this.props.point.types_id.includes(type.id);
        });

        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <DumbTypeList
                    title={this.props.t('generic.types')}
                    types={types}
                    loading={this.props.typesPending}
                />
            </div>
        );
    }

    renderMedias() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <MediaBlocs
                    app={this.props.app}
                    entity={this.props.point}
                    medias={this.props.point.medias || []}
                    pendingMedias={this.props.pendingMedias}
                    postMedia={this.props.postPointMedia}
                    selectMime={this.selectMime}
                    uploadedMedias={this.props.uploadedMedias}
                    failedMedias={this.props.failedMedias}
                    currentLang={this.props.currentLang}
                />
            </div>
        );
    }

    renderComment() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <CommentList
                    title={this.props.t('generic.comments')}
                    user={this.props.user}
                    comments={this.props.point.comments}
                    handleDeleteComment={this.handleDeleteComment}
                />
            </div>

        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.point || this.state.loadingPdfExport) {
            return <Loading paper={false} />;
        } else {
            return (
                <div style={styles.container}>
                    {this.props.point.source === EXTERNAL ? <ImportIndicator />: null}
                    {this.renderMenu()}
                    {this.renderDeletePointDialog()}
                    {this.state.commentToDelete && this.renderDeleteCommentDialog(this.state.commentToDelete)}

                    <h3 style={style.navigation}>
                        {this.props.t('module.open_explore.point')} / {this.props.t('generic.detail')} - {this.props.point.name}
                    </h3>
                    <div className="row">
                        {this.renderMap()}
                        {this.renderInformation()}
                        {this.renderTypes()}
                        {this.renderMedias()}
                        {ModuleService.hasModule(this.props.app, ModuleService.COMMENTS) && this.renderComment()}
                    </div>

                </div>
            )
        }
    }

}

function mapStateToProps(state, ownProps) {
    return {
        mapStyle: state.ui.mapStyle,
        error: state.apps.error || state.points.error,
        user: state.auth.content,
        loading: state.apps.pending || state.points.pending || state.customFields.pending || state.types.pending,
        sending: state.points.sending,
        point: state.points.currentPoint,
        currentLang: state.ui.currentLang,
        app: state.apps.currentApplication,
        pendingMedias: state.points.pendingMedias,
        uploadedMedias: state.points.uploadedMedias,
        failedMedias: state.points.failedMedias,
        currentMedia: state.points.currentMedia,
        types: state.types.content,
        typesPending: state.types.pending,
        commentSending: state.comments.sending,
        customFields: state.customFields.content
    };
}

export default connect(mapStateToProps, {
    deleteComment,
    postPointMedia,
    fetchApp,
    fetchPoint,
    getPoint,
    getTypes,
    getCustomFields,
    deletePoint
})(withTranslation(PointPage));



// WEBPACK FOOTER //
// src/containers/openexplore/PointPage/PointPage.js